 document.addEventListener("DOMContentLoaded", function () {
    const swiperElement = document.querySelector(".mySwiper-template--18275229008035__image_block_XFMCJ");
      if (swiperElement) { 
        const swiperss = new Swiper(swiperElement, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoplay: {
            delay: 5000,
          },
          navigation: {
            nextEl: ".swiper-button-nxt",
            prevEl: ".swiper-button-prv",
          },
        });
        //console.log("Swiper initialized:", swiperss);
      } else {
        //console.error("Swiper container not found for section:", "");
      }
     
    })